import { apiFetch } from "../utils/apiFetch"

export type PctLookupApplicant = {
  name: string
  countryCode: string | null
}

export type PctLookupResult = {
  title: string | null
  internationalFilingDate: string | null
  applicants: PctLookupApplicant[]
}

// Looks the PCT application up at the EPO (Open Patent Services)
export function lookupPctApplication(number: string) {
  return apiFetch(`/api/epo-ops/pct?number=${encodeURIComponent(number)}`) as Promise<PctLookupResult>
}
